import { Text } from '@/shared/ui/primitives';
import type { FC } from 'react';

import type { ClientDetailPass } from '@/types';
import { TEST_ID_BUILDERS } from '@/testIds';
import { Pill } from '@/shared/ui';
import { formatStartsIn } from '../../model/formatStartsIn';
import styles from './FuturePassesCard.module.css';

interface FuturePassRowProps {
  pass: ClientDetailPass;
  onClick: (pass: ClientDetailPass) => void;
}

export const FuturePassRow: FC<FuturePassRowProps> = ({ pass, onClick }) => {
  return (
    <button
      type="button"
      className={styles.row}
      onClick={() => onClick(pass)}
      data-testid={TEST_ID_BUILDERS.passByName(pass.name)}
    >
      <div className={styles.body}>
        <Text variant="subheadline" weight="medium" className={styles.name}>
          {pass.name}
        </Text>
        <Text variant="caption" weight="regular" className={styles.subtitle}>
          {formatStartsIn(pass.startsAt)}
        </Text>
      </div>
      <Pill tone="neutral" mode="outline">
        Upcoming
      </Pill>
    </button>
  );
};
